export default {
  '***': {
    '***': {
      '***': {
        displayFilters: null,
        staticFilters: [
          {
            label: 'Age',
            code: 'age',
            multi: true,
            options: [
              {
                label: '18-34',
                value: 1,
                selected: false
              },
              {
                label: '35-49',
                value: 2,
                selected: false
              },
              {
                label: '50-64',
                value: 3,
                selected: false
              }
            ]
          },
          {
            label: 'Gender',
            code: 'gender',
            multi: true,
            options: [
              {
                label: 'Male',
                value: 1,
                selected: false
              },
              {
                label: 'Female',
                value: 2,
                selected: false
              },
              {
                label: 'Prefer Not to Answer',
                value: 3,
                selected: false
              }
            ]
          },

          {
            label: 'Sufferer',
            // excludeFromVerbatims: true,
            code: 'sufferer',
            multi: true,
            options: [
              {
                label: 'DyD',
                value: 1,
                selected: false
              },
              {
                label: 'Non DyD',
                value: 2,
                selected: false
              }
            ]
          }
        ]
      }
    }
  }
};


// WEBPACK FOOTER //
// ./src/app/configuration/Pfizer/config/components/scorecard/ScorecardView/ScorecardFilter/index.js